import { useParams, useSearchParams } from "react-router-dom";
import ViewReviewHeader from "src/components/pages/Summary/ViewReview/ViewReviewHeader";
import Section from "src/components/shared/EntriesGenerator/Section/Section/Section";
import CheckListsModal from "src/generator/_Modals/CheckListsModal/CheckListsModal";
import { useVerifyEntries } from "src/pages/Summary/Summary.hooks";
import VerificationSignature from "src/pages/Summary/VerifyEntries/VerificationSignature/VerificationSignature";
import { PageContainer } from "src/styled";
import { getYachtId } from "src/utils";

const ViewAuditEntry = () => {
  const { idType, lbeidOrPartId, aid } = useParams();
  const [searchParams] = useSearchParams();
  const yachtid = searchParams.get("yachtid") ?? getYachtId();
  const { sections, restricted, authorized, idata, ...headerProps } =
    useVerifyEntries(
      "get-review-entry-reviews",
      "get-reviews-flag",
      {
        params: {
          yachtid,
          [String(idType)]: lbeidOrPartId,
          aid,
        },
      },
      yachtid,
    );

  return (
    <PageContainer>
      <ViewReviewHeader {...headerProps} audit />
      {/* {restricted === true && authorized === false ? (
        <AuthLogbookModal
          opened={true}
          open={open}
          close={close}
          lbid={lbid ?? ""}
        />
      ) : null} */}

      {(!restricted && !authorized) ||
      (restricted === true && authorized === true)
        ? sections.map((s, i) => <Section key={i} sIndex={i} section={s} />)
        : null}

      {idata && <VerificationSignature idata={idata} title="Signature" />}

      <CheckListsModal type="summary" />
    </PageContainer>
  );
};

export default ViewAuditEntry;
